// ArticleMedia.jsx - updated for Strapi v5 flat response
import React from 'react';

const ArticleMedia = ({ media }) => {
  if (!media) return null;

  // Strapi v5: response is flat, no "data.attributes" wrapper
  // Strapi v4: response is nested under "data.attributes"
  const attrs = media?.data?.attributes || media;

  if (!attrs?.url) return null;

  const serverBase = process.env.NEXT_PUBLIC_SERVER_URL?.replace('/api', '') || '';
  const imageUrl = attrs.url.startsWith('http') ? attrs.url : `${serverBase}${attrs.url}`;

  return (
    <figure className="article-media my-6">
      <img
        src={imageUrl}
        alt={attrs.alternativeText || 'Article Image'}
        style={{ maxWidth: '100%', height: 'auto' }}
        loading="lazy"
      />
      {attrs.caption && (
        <figcaption className="text-sm text-gray-500 mt-2 text-center">
          {attrs.caption}
        </figcaption>
      )}
    </figure>
  );
};

export default ArticleMedia;